/**
 * @author Fernando Ruano
 * @file index.js
 * @description App Card Layout Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './styles.module.css';

/**
 * App Card Layout Component.
 * @return { Node } React App Card Layout Component
 */
const AppCardLayout = ({ children, bgColor = 'bg-white' }) => {
  return (
    <div
      className={`${styles.contentBoardLayout} ${bgColor}`}
      style={{
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        height: '100%'
      }}>
      {React.Children.only(children)}
    </div>
  );
};

/**
 * @name AppCardLayout.propTypes
 * @type { Object }
 */
AppCardLayout.propTypes = {
  children: PropTypes.element.isRequired,
  bgColor: PropTypes.string
};

/**
 * Default props
 */
AppCardLayout.defaultProps = {};

export default AppCardLayout;
